export const RouteValues = {
    CHANGE_VEHICLE: '/changeVehicle',
    DASHBOARD: '/dashboard',
    DEAL_HISTORY: '/dealHistory',
    DEFAULT: '/',
    CREDIT_BUREAU: '/creditBureau',
    CREDIT_DECISION: '/creditDecision',
    DDJ: '/manage-documents',
    AUDIT_LOG: '/audit-log',
    ROLE_ASSUMPTION: '/role-assumption',
    NO_DEALERSHIPS: '/no-dealerships',
    OPEN_DEAL: '/open-deal'
};
